import { Injectable } from '@angular/core';
import { AxiosError } from 'axios';
import { ApiResponse } from './api-types.model';
import { ToasterService } from '@shared/services/toaster/toaster';
import { LoadingService } from '../loading/loading.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  delete(arg0: string) {
    throw new Error('Method not implemented.');
  }
  constructor(
    private toaster: ToasterService,
    private loadingService: LoadingService,
  ) {}

  // Safe API call wrapper
  async safeApiCall<T>(
    apiCall: () => Promise<ApiResponse<T>>,
    fallbackMessage = 'Something went wrong',
  ): Promise<ApiResponse<T>> {
    const requestKey = `api-${Date.now()}`;
    try {
      this.loadingService.show(requestKey);
      return await apiCall();
    } catch (error: AxiosError | any) {
      return this.handleApiError(error, fallbackMessage, apiCall);
    } finally {
      this.loadingService.hide(requestKey);
    }
  }

  // Centralized error handling
  // private handleApiError<T>(
  //   error: AxiosError | any,
  //   fallbackMessage: string,
  //   apicall?: () => void
  // ): ApiResponse<T> {
  //   let response: ApiResponse<T>;

  //   if (error.isAxiosError && error.response) {
  //     const data = error.response.data as ApiResponse<T>;
  //     response = {
  //       success: false,
  //       title: data?.title || 'Error',
  //       data: data?.data || null,
  //       errors: data?.errors || [fallbackMessage],
  //       statusCode: data?.statusCode || error.response.status,
  //       innerExceptionMessage: data?.innerExceptionMessage || null,
  //     };
  //   } else {
  //     response = {
  //       success: false,
  //       title: 'Error',
  //       data: null,
  //       errors: [fallbackMessage],
  //       statusCode: 0,
  //       innerExceptionMessage: null,
  //     };
  //   }

  //   // Show toast automatically
  //   const message = response.errors?.join(', ') || fallbackMessage;
  //   this.toaster.showError(message, "Api Error", "Report if this was Unexpected", () => {throw new Error("Api call failed: " + apicall + " with error: " + message)});

  //   return response;
  // }

  private handleApiError<T>(
    error: AxiosError | any,
    fallbackMessage: string,
    apicall?: () => void
  ): ApiResponse<T> {
    let response: ApiResponse<T>;

    if (error?.response) {
      const raw = error.response.data;

      // 🔥 LOG raw once to verify structure
      // console.log('🔥 RAW BACKEND ERROR:', raw);

      response = {
        success: false,
        title: raw?.title || raw?.Title || 'Error',
        data: raw?.data || raw?.Data || null,
        errors: raw?.errors || raw?.Errors || [raw?.message] || [fallbackMessage],
        statusCode: raw?.statusCode || raw?.StatusCode || error.response.status,
        innerExceptionMessage: raw?.innerExceptionMessage || raw?.InnerExceptionMessage || null,
      };
    } else {
      response = {
        success: false,
        title: 'Error',
        data: null,
        errors: [fallbackMessage],
        statusCode: 0,
        innerExceptionMessage: null,
      };
    }

    const message = (response.errors?.length ? response.errors.join(', ') : response.title)|| fallbackMessage;

    this.toaster.showError(message, response.title || 'Api Error', 'Report if unexpected', () => {
      throw new Error('API failed: ' + JSON.stringify(response));
    });

    return response;
  }
}
